import uspCarousel from "./usp-carousel";

uspCarousel('.block__usp .usp-items__item');
